import { Component, inject, output, signal, WritableSignal } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { NgClass, TitleCasePipe } from "@angular/common";
import { AuthService } from '../../../services/auth.service';
import { ApiService } from '../../../../api/services/api.service';
import { take } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { CopyToClipboardCopiedDirective } from '../../../directives/copy-to-clipboard-copied.directive';
import { environment } from '../../../../../../../environments/environment';
import { BenefitBusinessAccountComponent } from "../../benefit-business-account/benefit-business-account.component";

const TAP_HIGHLIGHT_MS = 280;

@Component({
  selector: 'app-dialog-switch-account',
  imports: [
    MatIcon,
    NgClass,
    BenefitBusinessAccountComponent
],
  templateUrl: './dialog-switch-account.component.html',
  styleUrl: './dialog-switch-account.component.scss'
})
export class DialogSwitchAccountComponent {
  temporaryState: WritableSignal<'account-list' | 'add-business-account'> = signal<'account-list' | 'add-business-account'>('account-list')
  public readonly authService: AuthService = inject(AuthService);
  private readonly _apiService: ApiService = inject(ApiService);
  public readonly matDialogRef = inject(MatDialogRef);

  readonly touchScrolled = signal(false);
  readonly tapHighlightRowId = signal<string | null>(null);
  private _touchedRowId: string | null = null;
  private _tapHighlightTimeout: ReturnType<typeof setTimeout> | null = null;

  onTouchStart(e: TouchEvent): void {
    this.touchScrolled.set(false);
    const row = (e.target as HTMLElement).closest?.('.switch-account-row');
    this._touchedRowId = row?.getAttribute('data-row-id') ?? null;
  }

  onTouchMove(): void {
    this.touchScrolled.set(true);
    this._touchedRowId = null;
  }

  onTouchEnd(): void {
    if (!this.touchScrolled() && this._touchedRowId != null) {
      this.tapHighlightRowId.set(this._touchedRowId);
      if (this._tapHighlightTimeout) clearTimeout(this._tapHighlightTimeout);
      this._tapHighlightTimeout = setTimeout(() => {
        this.tapHighlightRowId.set(null);
        this._tapHighlightTimeout = null;
      }, TAP_HIGHLIGHT_MS);
    }
    this._touchedRowId = null;
  }

  changeAccount(uuid: string): void {
    this._apiService.putActiveTelegramAccount(uuid).pipe(take(1)).subscribe({
      next: () => {
        console.log(uuid)
        this.authService.changeAccount(uuid);
        this.matDialogRef.close();
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 150);
      }
    });
  }
}
